module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid card-desktop"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-desktop-side"
  }, [_c('desktop-sidebar')], 1), _vm._v(" "), _c('div', {
    staticClass: "card-desktop-main"
  }, [_c('div', {
    staticClass: "card crd-header"
  }, [_c('desktop-header')], 1), _vm._v(" "), _c('div', {
    staticClass: "card card-desktop-body",
    staticStyle: {
      "background-color": "#f9f9f9"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "background": "#f8d63d",
      "color": "#000000"
    }
  }, [_vm._l((_vm.set_categories), function(cat) {
    return _c('li', [_vm._v(_vm._s(cat.category_name) + "\r\n                                "), _vm._m(0, true)])
  }), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "1em",
      "background": "#f8d63d",
      "color": "#000000"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h4', [_vm._v("Incredibly satisfying Reviews")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1.02em"
    }
  }, _vm._l((_vm.businesses), function(business, index) {
    return ((index < 9) && (business.business_brand_image && (business.business_brand_image != ''))) ? _c('div', {
      staticClass: "col-xs-6"
    }, [_c('div', {
      staticClass: "card container-fluid",
      staticStyle: {
        "margin-bottom": "1em",
        "padding": "0.8em",
        "background-color": "#ffffff",
        "border-radius": "8px"
      }
    }, [_c('a', {
      staticClass: "card-link",
      attrs: {
        "href": '/' + business.business_username
      }
    }, [_c('div', {
      staticClass: "col-xs-2",
      staticStyle: {
        "height": "52px",
        "border-radius": "8px",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      style: ({
        'background-image': 'url(' + business.business_brand_image + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7"
    }, [_c('h4', {
      staticStyle: {
        "margin-top": "5px",
        "text-align": "left",
        "white-space": "nowrap",
        "overflow": "hidden",
        "text-overflow": "ellipsis"
      }
    }, [_c('span', {
      staticStyle: {
        "font-weight": "bolder"
      }
    }, [_vm._v(_vm._s(business.business_name))])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "line-height": "0.3"
      }
    }, [_c('span', [_vm._v("@" + _vm._s(business.business_location))]), _vm._v(" "), _c('span', [_vm._v("," + _vm._s(business.business_address))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3 mp0"
    }, [_c('p', {
      staticClass: "rate",
      staticStyle: {
        "line-height": "0.3",
        "margin-top": "0.6em"
      }
    }, _vm._l((5), function(rate) {
      return _c('i', {
        staticClass: "fas fa-star",
        staticStyle: {
          "padding-right": "3px"
        }
      })
    }))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Find an Restaurant, Order Plug, Vendor etc "
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2edb9422"}!./src/pages/Search/desktop/desktop.html
// module id = 561
// module chunks = 0